export default __webpack_public_path__ + "static/media/Scentpad-marine.208ccc5a.jpg";